// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading[data-v-1429599b]{min-height:3em}.cont[data-v-1429599b]{position:relative;height:45px;width:47px}.ring[data-v-1429599b]{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.percent[data-v-1429599b]{font-size:1.5em;font-weight:700;color:#009b48;display:inline-block}.leaf[data-v-1429599b]{margin-left:.25em;max-height:35px}", ""]);
// Exports
module.exports = exports;
